<script setup lang="ts">
import { defineProps,defineEmits, onMounted, ref, reactive, watch, computed} from "vue";
import axios from 'axios'
import AxiosVideoService from "../utils/axiosVideoService";
import { useRouter } from 'vue-router';
import { useLanguage } from "../utils/useLanguage";
import { useUserStore } from "../store/userStore";
const userStore = useUserStore();

const { t } = useLanguage();
const axiosVideoService = new AxiosVideoService();
const axiosWithToken = axios.create({
  withCredentials: true,  // axios 專用設定，不是 header
  headers: {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${localStorage.token ?? ''}`,
  },
});

const router = useRouter();

const emit = defineEmits(['update:status'])
const props = defineProps({  
    status: {
        type: Boolean,
        required: false,
    }
})
const boolChange = () => {
    emit('update:status',false)
}

const loadingInfo = reactive({
    status: false,
    title: "Video processing",
})
const modalInfo = reactive({
    type: "alert",
    status: false,
    title: "Fail!",
    content: t('subtitleGenerationFailed'),
    msg: "chatnow"
})

/* Sentence List 句子 */
let allSentence: any = ref([]);
let stCount: any = ref(10);
let stPage: any = ref(0);
let cstPage: any = ref(0);
function getNotesSentence(page: number, size: number){
    axiosVideoService.SentenceList(localStorage.token, page, size, learning_language.value)
    .then((res: any) => {
        // allSentence.value = res.data.items

        // if(res.data.page > res.data.pages){
        //     getNotesSentence(res.data.pages, size);
        // }else{
        //     stPage.value = res.data.pages
        //     cstPage.value = res.data.page
        // }
        stPage.value = res.data.pages
        cstPage.value = res.data.page
        
        let stArr:any = res.data.items
        // 按照時間排序
        stArr = stArr.sort(function (a:any, b:any) {
            return a.updated_at < b.updated_at ? 1 : -1;
        });
        for(let i = 0; i < stArr.length; i++){
            allSentence.value.push(stArr[i])
        }

        // console.log('list sentence',allSentence.value);
    })
    .catch((res: any) => {
      console.log('list sentence failed',res.data);
    })


}
// function getVideoTitle(id: string){
//     console.log("checking video status")
//     axiosVideoService.getVideoById(localStorage.token, id)
//     .then((res: any) => {
//         return res.data.title
//     })
//     .catch((res: any) => {
//         console.log('get video status fail',res, id);
//     })
// }

/* Vocabulary List 單字 */
let allVocabulary: any = ref([]);

let vocsCount: any = ref(10); // 顯示20個
let vocsPage: any = ref(0);
let cVocsPage: any = ref(0);

function getVocsNotes(page: number, size: number){
    axiosVideoService.VocabularyList(localStorage.token, page, size, learning_language.value)
    .then((res: any) => {
        // let pages = res.data.pages
        
            // allVocabulary.value = res.data.items
            vocsPage.value = res.data.pages
            cVocsPage.value = res.data.page
            
            let vocsArr:any = res.data.items
            // 按照時間排序
            vocsArr = vocsArr.sort(function (a:any, b:any) {
                return a.updated_at < b.updated_at ? 1 : -1;
            });
            for(let i = 0; i < vocsArr.length; i++){
                allVocabulary.value.push(vocsArr[i])
            }

            // console.log('vocablary list',allVocabulary.value); 
    })
    .catch((r: any) => {
        console.log('vocablary list failed',r.data);
    })
    
}
const vocabularyData = ref({
    id: "",
    text: "",
    pronunciation: "",
    meaning: "",
    user_saved: false
})
/* Save Vocabulary 儲存單字 */
function saveVb(vocabulary: any){
    loadingInfo.status = true

    loadingInfo.title = 'Unsave Vocabulary'

    vocabularyData.value.user_saved = true

    axiosWithToken.post("/api/v1/vocabulary/save/"+ vocabulary)
    .then((res: any) => {
        loadingInfo.status = false
        allVocabulary.value = allVocabulary.value.filter((item :any) => item.id !== res.data.id);
    })
    .catch((res: any) => {
        modalInfo.status = true
        modalInfo.msg = "confirm"
        modalInfo.title = "Something Wrong"
        modalInfo.content = "Sorry, failed to unsave the vocabulary. Please try again."

        loadingInfo.status = false
        console.log('unsave vocabulary failed',res);
    })
}
/* Delete Sentance 刪除句子 */
function deleteSt(id: string){
    loadingInfo.status = true

    loadingInfo.title = 'Delete Sentance'

    axiosWithToken.delete("/api/v1/video/sentence/"+ id)
    .then((res: any) => {
        loadingInfo.status = false
        allSentence.value = allSentence.value.filter((item :any) => item.id !== id);
        console.log('delete sentence',allSentence.value);
    })
    .catch((res: any) => {
        modalInfo.status = true
        modalInfo.msg = "confirm"
        modalInfo.title = "Something Wrong"
        modalInfo.content = "Sorry, failed to delete the sentence. Please try again."

        loadingInfo.status = false
        console.log('delete sentence failed',res);
    })
}

const tab = ref<string[]>([]); // 勾選的分級

const openVoc = reactive({
    status: true,
})
const openSt = reactive({
    status: false,
})
function toggleVoc(){
    // getVocsNotes(1, vocsCount.value);
    openVoc.status = true;
    openSt.status = false;
    
}
function toggleSt(){
    // getNotesSentence(1, stCount.value);
    openSt.status = true;
    openVoc.status = false;

}
watch(() => props.status, (newStatus) => {
    allSentence.value = []
    allVocabulary.value = []
    getVocsNotes(1, vocsCount.value);
    getNotesSentence(1, stCount.value);
});


onMounted(() => {
    // 抓取前20個單字
    getVocsNotes(1, vocsCount.value);
    getNotesSentence(1, stCount.value);

})

const learning_language = ref<string>(
  localStorage.getItem("learningLanguage")?.trim() || "Simplified_Chinese"
)

watch(learning_language, (val) => {
  const next = (val ?? "").trim() || "Simplified_Chinese"
  localStorage.setItem("learningLanguage", next)
})
// const isInternalEnglish = computed(() => {
//   const ll = (learning_language.value ?? "").trim()
//   const email = (userStore.email ?? "").trim().toLowerCase()
//   return ll === "English" && email.endsWith("@mimir.com")
// })
</script>
<template >
 <div class="fixed noteBook" :class="[props.status ? 'open': '']" style="background-image: url('/notebook.png')">
    <div class="icon-close pointer abs bg-black-4 circle white-1" style="right: 10%; top: 5%;z-index: 1;" @click="boolChange()"></div>
    <div class="nContent abs p-center">
        <div class="flex gap-10 column-sm">

            <input type="radio" id="vocabulary" value="vocabulary" v-model="tab" checked>
            <label class="levelItem  btn chbox tag pointer" for="vocabulary" @click="toggleVoc">{{ t('Vocabulary') }}</label>
            <input type="radio" id="sentence" value="sentence" v-model="tab">
            <label class="levelItem  btn chbox tag pointer" for="sentence" @click="toggleSt">{{ t('Sentence') }}</label>
        </div>
  

        <div v-if="openVoc.status" class="nPage">
                
            <h2 class="title-1 mb-10">{{ t('Your Vocabulary List') }}</h2>
            
            <ul class="flex column gap-10">
                <li  v-for="(item, index) in allVocabulary" :key="index" class="v-card bg-white-4">
                    <p class="i-flex a-center gap-5">{{ item.text }}
                        <span :id="item.id" class="icon-delete md pointer black-3"  @click="saveVb(item.id)" ></span> 
                    </p>
                    <p class="fs-075r fw-bold black-3" >{{ item.pronunciation }}</p>
                    <p class="label">{{ item.meaning }}</p>
                    
                </li>
            </ul>
            
            <div class="t-center p-20" v-if="(cVocsPage < vocsPage) && (allVocabulary.length > 0)">
                <div class="btn capsule outline br-black black-1" @click="getVocsNotes((cVocsPage + 1), vocsCount)" >{{ t('See More') }}</div>
            </div>
        </div>
        
        <div v-if="openSt.status" class="nPage">
            
            <h2 class="title-1 mb-10">{{ t('Your Sentence List') }}</h2>
            
            <ul class="flex column gap-10">
                <li  v-for="(item, index) in allSentence" :key="index" class="v-card bg-white-4">
                    <p class="font-2 mb-5">{{item.en_text}}
                        <span :id="item.id" class="icon-delete md pointer black-3"  @click="deleteSt(item.id)" ></span> 
                    </p>
                    <p class="font-3">{{item.foreign_text == null ? item.foreign_text : item.zh_text}}</p>
                    <!-- <p class="font-2 mb-5">{{getVideoTitle(item.id)}}</p> -->
                </li>
            </ul>
           
            <div class="t-center p-20" v-if="(cstPage < stPage) && (allSentence.length > 0)">
                    <div class="btn capsule outline br-black black-1" @click="getNotesSentence((cstPage + 1), stCount)" >See More</div>
            </div>
        </div>
      
    </div>

</div>

<Loading v-model:status="loadingInfo.status" v-model:title="loadingInfo.title"></Loading>

</template>
<style scoped>
@import '../assets/css_lib/themimir.css';

.noteBook{
    z-index: 999999;
    left: 50%;
    transform: translate(-50%, -50%);
    top: calc(100% + 50vh);
    transition: all .5s ease;
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
    width: 500px;
    height: 90vh;
    overflow: hidden;

}
@media (orientation: landscape) and (max-width: 960px) {
    .noteBook{
        background-size: cover;
    }
}
.noteBook.open{
    top: 50%;
}
.nHeader{
    padding: 16px;
    border-bottom: .0625rem solid #f3f3f3;
}
.nContent{
    max-width: 350px;
    width: 75vw;
    max-height: 600px;
    height: 90vh;
    /* padding-top: 40px; */
}
.nPage{
    overflow: scroll;
    height: calc(100% - 30px);
    padding: 10px;
}
@media all and (max-width: 540px) {
    .nHeader{
        height: 60px;
    }
    .nContent{
        width: 100vw;
        /* max-height: calc(100vh - 60px); */
    }

}
.v-card{
    border-radius: 5px;
    padding: 20px;
}
</style>